import React, { useContext, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { EstateConditionType, EstateContext } from '@/hooks/useEstateContext'
import { Spacing } from '@inter/inter-ui/components/Spacing'
import { Button } from '@inter/inter-ui/components/Button'
import { Text } from '@inter/inter-ui/components/Text'
import { Flex } from '@inter/inter-ui/components/Flex'
import { RadioGroup } from '@inter/inter-ui/components/RadioGroup'
import RadioCard from '@/components/RadioCard'
import routes from '@/routes/RoutesNames'

import options from './options.json'

const EstateCondition = () => {
  const { estateCondition, setEstateCondition, setStep, isEditing } = useContext(EstateContext)
  const [selected, setSelected] = useState<EstateConditionType>('' as EstateConditionType)
  const navigate = useNavigate()

  useEffect(() => {
    setStep(3)
    setSelected(estateCondition)
  }, [estateCondition, setStep])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setEstateCondition(selected)
    !isEditing ? navigate(`/${routes.FORM_FINISHING_STANDARD}`) : navigate(`/${routes.FORM_REVIEW}`)
  }

  return (
    <form onSubmit={(event) => onSubmit(event)}>
      <Flex direction="column" justifyContent="space-between">
        <Text variant="headline-h3" semiBold>
          Qual o estado de conservação do apartamento?
        </Text>
        <Spacing mb="xxs" />
        <Text variant="body-3">Avalie a saúde estrutural e estética do seu apartamento:</Text>
        <Spacing mb="lg" />
        <RadioGroup
          name="options"
          value={selected}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setSelected(event.target.value as EstateConditionType)
          }
          style={{ display: 'flex' }}
        >
          <Flex direction="column">
            {Object.keys(options).map((option) => (
              <React.Fragment key={option}>
                <RadioCard
                  id={`estate-condition-${option.toLowerCase().replace('_', '-')}`}
                  value={option}
                  title={options[option as EstateConditionType].title}
                  description={options[option as EstateConditionType].description}
                />
                <Spacing mb="xs" />
              </React.Fragment>
            ))}
          </Flex>
        </RadioGroup>

        <Spacing mb="sm" />
        <Button type="submit" fullWidth disabled={!selected}>
          Continuar
        </Button>
      </Flex>
    </form>
  )
}

export default EstateCondition
